<template>
  <div class="cbg-white-container blog-details-main theme--light v-card p-3">
    <CModal
      :show.sync="rejectModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Reason"
      size="lg"
      color="dark"
      class="reject-modal-box"
    >
      <CTextarea
        v-model="reasonData.rejected_reason"
        type="text"
        maxlength="150"
        label="Reason"
        name="reason"
        placeholder="Reason"
        horizontal
        rows="2"
      />
      <span
        v-if="reasonData.rejected_reason === '' && alert === true"
        class="text-danger required-fields"
        >{{ requiredAlert }}</span
      >

      <template #header>
        <h6 class="modal-title">Reason for Reject</h6>
      </template>

      <template #footer>
        <v-btn @click="rejectModal = false" class="btn btn-danger"
          >Cancel</v-btn
        >
        <v-btn class="btn btn-success" @click="closeRejectModal()"
          >Submit</v-btn
        >
      </template>
    </CModal>

    <loader v-if="showLoader"></loader>

    <div class="cmd-pad">
      <div class="d-flex w-100 border-top pt-8 lgs-flex-dir-col">
        <div class="blog-image cme-blog-image w-45 pos-r lgs-full-width">
          <div class="blog-image-box w-100 lgs-full-width">
            <div class="blog-in-img pos-r w-100">
              <image-view
                v-if="cmeDetails.event_image && cmeDetails.event_image.length"
                :src="cmeDetails.event_image[0]"
                alt="CME Event image"
                class="w-100"
              />
              <image-view
                v-else
                :src="'/img/avatars/event-image.png'"
                alt="CME Event image"
                class="w-100"
              />
              <div
                class="
                  blog-tag
                  d-flex
                  justify-center
                  reject
                  btn-white
                  pt-2
                  pb-2
                  pos-a
                "
              >
                <p class="m-0 text-white text-capitalize">
                  <b>{{ cmeDetails.event_mode }}</b>
                  <span class="blog-date pr-1">
                    <span class="pl-2 pr-1">/</span>
                    {{ getDYDate(cmeDetails.event_date) }}
                  </span>
                  {{ getMYDate(cmeDetails.event_date) }}
                </p>
              </div>
            </div>
            <div class="blog-in-cont">
              <div class="text d-flex pt-4">
                <div>
                  <b class="text-capitalize">Organization Name:</b>
                </div>
                <div class="pl-3 eventmode">
                  <p class="mb-1 text-capitalize">
                    {{ cmeDetails.organization_name }}
                  </p>
                </div>
              </div>

              <div class="text d-flex">
                <div>
                  <p class="mb-0 text-capitalize">
                    <b>Event organizer:</b>
                  </p>
                </div>
                <div class="pl-3 eventmode">
                  <p class="mb-1 text-capitalize event-mob-margin">
                    {{ cmeDetails.event_organizer }}
                  </p>
                </div>

                <div
                  class="pl-3 eventmode eventpaid successcolor pos-a d-align"
                >
                  <div>
                    <img
                      src="/img/avatars/freee.png"
                      alt="Charge image"
                      class="mr-2 position-relative"
                    />
                  </div>
                  <p class="successcolor text-capitalize mb-0">
                    {{ cmeDetails.event_charge }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="blog-content-box cme-blog-content-box w-55 lgs-full-width">
          <div
            v-if="cmeDetails.status == 'published'"
            class="
              col-sm-12
              p-0
              blog-links
              d-just-space
              my-4
              mt-0
              xs-flex-dir-col
              lg-flex-dir-col
            "
          >
            <div class="share-blog d-align cme-detail-share-blog">
              <share-blogs></share-blogs>
            </div>
          </div>
          <h5 class="mt-3 text-capitalize text-ellipsis">
            {{ cmeDetails.event_name }}
          </h5>
          <div
            class="d-flex d-just-space xs-flex-dir-col ml-box"
            v-if="cmeDetails.event_invitation_type"
          >
            <p class="mb-0 text-capitalize">
              <b>Invitation for :</b>
              <span
                class="text-capitalize"
                v-if="
                  !cmeDetails.event_invitation_type
                    .map((el) => el.type)
                    .includes('Doctor')
                "
              >
                {{
                  cmeDetails.event_invitation_type
                    .map((el) => el.type)
                    .join(",")
                }}
              </span>
              <span
                v-if="
                  cmeDetails &&
                  cmeDetails.event_invitation_type &&
                  cmeDetails.event_invitation_type[0] &&
                  cmeDetails.event_invitation_type[0]['speciality'] &&
                  cmeDetails.event_invitation_type[0]['speciality'] &&
                  cmeDetails.event_invitation_type[0]['speciality'].length > 1
                "
                >({{ cmeDetails.event_invitation_type[0]["speciality"][0] }},
                {{
                  cmeDetails.event_invitation_type[0]["speciality"][1]
                }})</span
              >
              <span
                v-if="
                  cmeDetails &&
                  cmeDetails.event_invitation_type &&
                  cmeDetails.event_invitation_type[0] &&
                  cmeDetails.event_invitation_type[0]['speciality'] &&
                  cmeDetails.event_invitation_type[0]['speciality'] &&
                  cmeDetails.event_invitation_type[0]['speciality'].length == 1
                "
                class="pl-1"
              >
                ({{ cmeDetails.event_invitation_type[0]["speciality"][0] }})
              </span>
              <span
                v-if="
                  cmeDetails &&
                  cmeDetails.event_invitation_type &&
                  cmeDetails.event_invitation_type[0] &&
                  cmeDetails.event_invitation_type[0]['speciality'] &&
                  cmeDetails.event_invitation_type[0]['speciality'] &&
                  cmeDetails.event_invitation_type[0]['speciality'].length > 2
                "
              >
                <v-btn
                  @click="showSpeciality = true"
                  class="btn more-plus text-capitalize ml-0"
                >
                  <span class="speciality-more-text text-success">more</span>
                </v-btn>
              </span>
            </p>
          </div>
          <div class="text d-flex pt-0 pb-1">
            <div>
              <b class="text-capitalize">Credit Points:</b>
            </div>
            <div class="pl-3 eventmode">
              <p
                v-if="!!cmeDetails.mmc_credit_points"
                class="text-capitalize mb-0"
              >
                Yes
              </p>
              <p v-else class="text-capitalize mb-0">No</p>
            </div>
          </div>
          <div class="xs-flex-dir-col">
            <p class="mb-1">{{ cmeDetails.contact_email }}</p>

            <p class="mb-1">{{ cmeDetails.contact_number }}</p>
          </div>

          <hr class="mt-2 mb-6" />

          <div
            class="brochure-box"
            v-if="cmeDetails.event_broucher && cmeDetails.event_broucher.length"
          >
            <div class="brochure-img-box-cont pos-r">
              <div class="brochure-img-box">
                <image-view
                  v-if="
                    cmeDetails.event_broucher &&
                    cmeDetails.event_broucher.length &&
                    cmeDetails.event_brochure_type == 'image'
                  "
                  :src="cmeDetails.event_broucher[0]"
                  alt="CME Event image"
                />
                <image-view
                  v-else
                  :src="'/img/avatars/file-pdf.png'"
                  alt="CME Event image"
                />
              </div>
              <div class="brochure-cont pos-a">
                <div
                  class="brochure-more btn-white"
                  @click="
                    checkIsPdf(cmeDetails)
                      ? showPdf(cmeDetails)
                      : showImage(cmeDetails)
                  "
                >
                  <b>+{{ cmeDetails.event_broucher.length }}</b>
                  <p>More</p>
                </div>
              </div>
              <p @click="showImage(cmeDetails)" class="pt-1">
                <b>View Brochure</b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 pt-4 cmd-pad">
      <hr class="my-4" />
      <h5 class="text-capitalize">
        <b>Tags</b>
      </h5>

      <div class="chip-list chip-tag">
        <v-chip
          v-for="(tag, i) in cmeDetails.tags"
          :key="i"
          class="text-capitalize text-black cursor mr-2"
          label
        >
          <router-link
            :to="{ name: 'CME Listing', params: { tag: tag } }"
            tag="p"
            class="text-capitalize m-0"
            >{{ tag }}</router-link
          >
        </v-chip>
      </div>
      <hr class="my-4" />
    </div>

    <div class="desc-box cmd-pad">
      <div class="desc-cont">
        <p v-html="cmeDetails.event_description"></p>
      </div>

      <hr class="my-4" />
    </div>

    <div class="col-sm-12 pt-2 flex-end mb-2 mob-f-s xs-flex-dir-col cmd-pad">
      <v-btn
        v-if="!cmeDetails.is_published && cmeDetails.status === 'pending'"
        color="success mr-4 xs-width"
        @click="openSwal('publish')"
        >Approve & publish</v-btn
      >
      <v-btn
        v-if="!cmeDetails.is_published && cmeDetails.status === 'pending'"
        class="xss-mt-5 xs-width"
        color="error"
        @click="openRejectModal()"
        >Reject</v-btn
      >

      <v-btn
        v-if="!cmeDetails.is_published && cmeDetails.status === 'unpublished'"
        color="success mr-4 xs-width"
        @click="openSwal('publish')"
        >Publish</v-btn
      >

      <v-btn
        v-if="!!cmeDetails.is_published && cmeDetails.status === 'published'"
        color="success mr-4 xs-width"
        @click="openUnpublishModal()"
        >Unpublish</v-btn
      >
    </div>

    <CModal
      :show.sync="slideModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="slides"
      size="lg"
      color="dark"
      class="slide-modal-box"
    >
      <div>
        <v-carousel>
          <v-carousel-item
            v-for="(item, i) in items"
            :key="i"
            :src="item.src"
            reverse-transition="fade-transition"
            transition="fade-transition"
          ></v-carousel-item>
        </v-carousel>
      </div>
    </CModal>
    <CModal
      :show.sync="unpublishModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Reason"
      size="lg"
      color="dark"
      class="reject-modal-box text-capitalize"
    >
      <CTextarea
        v-model="reasonData.unpublishReason"
        type="text"
        maxlength="150"
        label="Reason"
        name="reason"
        placeholder="Reason"
        horizontal
        rows="2"
      />
      <span
        v-if="reasonData.unpublishReason === '' && alert"
        class="text-danger required-fields"
        >{{ requiredAlert }}</span
      >

      <template #header>
        <h6 class="modal-title text-capitalize">Reason for Unpublishing</h6>
      </template>

      <template #footer>
        <v-btn @click="unpublishModal = false" class="btn btn-danger"
          >Cancel</v-btn
        >
        <v-btn class="btn btn-success" @click="closeUnpublishModal()"
          >Submit</v-btn
        >
      </template>
    </CModal>
    <light-box-new
      :images="lightboxImages"
      ref="lightbox"
      :show-light-box="false"
    ></light-box-new>
    <v-dialog
      v-if="pdfModal"
      v-model="pdfModal"
      width="900px"
      content-class="v-dialog-lg"
      persistent
    >
      <v-card class="min-height">
        <nav class="border-bottom theme--dark p-2 pl-1" data-booted="true">
          <div class="v-toolbar__content">
            <div class="flex-column">
              <div class="v-toolbar__title" style="margin-bottom: -5px">
                PDF
              </div>
            </div>
            <div class="spacer"></div>
            <button
              type="button"
              class="v-btn v-btn--icon theme--dark"
              @click="pdfModal = false"
            >
              <div class="v-btn__content cursor">
                <!-- <v-icon dark right>mdi-close-circle</v-icon> -->
                <img src="/img/avatars/remove.png" />
              </div>
            </button>
          </div>
        </nav>
        <v-card-text class="scrolling">
          <pdf-component
            :src="pdfLink"
            :styles="'width: 100%;height:800px'"
          ></pdf-component>
        </v-card-text>
      </v-card>
    </v-dialog>

    <section>
      <v-dialog
        v-model="showSpeciality"
        width="35rem"
        persistent
        scrollable
        content-class="speciality-modal"
      >
        <speciality
          :speciality="cmeDetails.event_invitation_type[0]['speciality']"
          @close="showSpeciality = false"
        />
      </v-dialog>
    </section>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import config from "@/config.js";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
import "@/assets/scss/_blogs.scss";
const Image = () => import("@/components/image.vue");
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const ShareBlogs = () => import("@/components/modals/shareBlog.vue");
const lightBoxNew = () => import("@/components/lightBoxNew.vue");
const loader = () => import("@/components/loader.vue");
import { pickSvg } from "@/views/SVG";
const Pdf = () => import("@/components/pdf.vue");
import { bus } from "@/main.js";
export default {
  data() {
    return {
      lightboxImages: [],
      currentPage: 1,
      recordPerPage: 3,
      commentDetails: [],
      commentNumber: "",
      reasonData: {
        rejected_reason: "",
        unpublishReason: "",
      },
      rejectModal: false,
      reasonModal: false,
      unpublishModal: false,
      cmeDetails: {},
      uploadedImgFullUrl: [],
      uploadedImg: [],
      slideModal: false,
      rejectReason: "",
      showSpeciality: false,
      slug: "",
      alert: false,
      requiredAlert: "This field is required.",
      items: [
        {
          src: "/img/avatars/health.jpeg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg",
        },
        {
          src: "/img/avatars/health.jpeg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg",
        },
      ],
      galleryModal: false,
      src: "",
      pdfLink: null,
      pdfModal: false,
      showLoader: false,
    };
  },

  mounted() {
    this.slug = this.$route.params.slug;
    this.getCmeDetails();
  },
  created() {
    bus.$emit("CHAT_BREADCRUMB_CHANGE", [
      {
        text: "Home",
        to: "/dashboard",
      },
      {
        text: "CME Listing",
        to: "/cme-list",
      },
      {
        text: this.cmeTitle,
      },
    ]);
  },

  components: {
    Datepicker,
    "image-view": Image,
    "share-blogs": ShareBlogs,
    ...pickSvg("deleteSVG"),
    "light-box-new": lightBoxNew,
    "pdf-component": Pdf,
    loader,
    speciality: () => import("@/views/cme/specilaityModal.vue"),
  },
  methods: {
    checkIsPdf(data) {
      const extention = data.event_broucher[0].split(".").pop();
      return extention === "pdf";
    },
    showPdf(pdf) {
      this.pdfLink = pdf.event_broucher[0];
      this.pdfModal = true;
    },
    getMYDate(date) {
      return dayJS(date).format(" MMMM YYYY");
    },
    getDYDate(date) {
      return dayJS(date).format("Do");
    },
    move(amount) {
      let newActive;
      const newIndex = this.active + amount;
      if (newIndex > this.slides) newActive = 1;
      if (newIndex === 0) newActive = this.slides;
      this.active = newActive || newIndex;
    },
    jump(index) {
      this.active = index;
    },
    getCmeDetailsPath() {
      this.$router.push(`/cme-list`);
    },
    openRejectModal() {
      this.rejectModal = true;
    },

    openUnpublishModal() {
      this.unpublishModal = true;
    },
    closeUnpublishModal() {
      this.updateCME("unpublish");
      if (!alert) {
        this.unpublishModal = false;
      } else {
        this.unpublishModal = true;
      }
    },

    closeRejectModal() {
      if (!alert) {
        this.rejectModal = false;
      } else {
        this.rejectModal = true;
      }
      this.rejectCME("rejected");
    },
    openSlideModal() {
      this.slideModal = true;
    },
    closeSlideModal() {
      this.slideModal = false;
    },
    showImage(data) {
      this.lightboxImages = data.event_broucher.map((el) => ({
        src: el,
        thumb: el,
        caption: "CME Images",
      }));
      this.$refs.lightbox.showImage(0);
    },
    openSwal(status) {
      if (status === "Approve & Publish") {
        Swal.fire({
          title: "Are you sure you want to Publish this event",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.updateCME(status);
          }
        });
      } else if (status === "publish") {
        Swal.fire({
          title: "Are you sure you want to Publish this event",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.updateCME(status);
          }
        });
      } else {
        Swal.fire({
          title: "Are you sure you want to Unpublish this event",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.updateCME(status);
          }
        });
      }
    },
    getCmeDetails() {
      this.showLoader = true;
      let url = `${config.BASE_URL}api/v2/admin/cme-events/${this.slug}`;
      this.$http.get(url, {}).then((response) => {
        if (response.body.status) {
          if (response.body.data) {
            this.cmeDetails = { ...response.body.data };
            this.showLoader = false;

            bus.$emit("CHAT_BREADCRUMB_CHANGE", [
              {
                text: "Home",
                to: "/dashboard",
              },
              {
                text: "CME Listing",
                disabled: false,
                to: "/cme-list",
              },
              {
                text: this.cmeDetails.event_name,
                disabled: true,
                to: this.$route.path,
              },
            ]);
          } else {
            this.cmeDetails = {};
            this.showLoader = false;
          }
        }
      });
    },
    rejectCME(status) {
      if (this.reasonData.rejected_reason == "") {
        this.alert = true;
        return false;
      } else {
        let obj;
        if (status === "rejected") {
          obj = {
            status: status,
            reason: this.reasonData.rejected_reason,
          };
        } else {
          obj = {
            is_deleted: true,
          };
        }

        let url = `${config.BASE_URL}api/v2/admin/cme-events/${this.cmeDetails._id}`;
        this.$http.put(url, obj).then((response) => {
          if (!!response.ok) {
            if (status === "rejected") {
              Swal.fire({
                title: "CME Event Rejected ",
                icon: "success",
                showCancelButton: false,
                confirmButtonText: "Ok",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.goTo("/cme-list");
                  this.rejectModal = false;
                }
              });
            }
          }
        });
      }
    },
    updateCME(status) {
      let obj;
      if (status === "publish") {
        obj = {
          status: status,
        };
      } else if (status === "unpublish") {
        if (this.reasonData.unpublishReason == "") {
          this.alert = true;
          return false;
        } else {
          obj = {
            status: status,
            reason: this.reasonData.unpublishReason,
          };
        }
      } else {
        obj = {
          is_deleted: true,
        };
      }
      let url = `${config.BASE_URL}api/v2/admin/cme-events/${this.cmeDetails._id}`;
      this.$http.put(url, obj).then((response) => {
        if (!!response.ok) {
          if (status === "publish") {
            Swal.fire({
              title: "CME Event Published Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok",
            }).then((result) => {
              if (result.isConfirmed) {
                this.goTo("/cme-list");
              }
            });
          } else {
            Swal.fire({
              title: "CME Event Unpublished Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok",
            }).then((result) => {
              if (result.isConfirmed) {
                this.unpublishModal = false;
                this.goTo("/cme-list");
              }
            });
          }
        }
      });
    },
    downloadCsv() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        status: this.status,
        role: this.cmerole,
        mmc_sort: this.cme_mmc_sort,
        mode: this.cme_mode,
        charge: this.cme_charge,
        speciality: this.doctor_speciality,
      };
      let url = `${config.BASE_URL}api/v2/admin/reports/doctor-list-csv`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.showLoader = false;
          const data = response.data.data;
          this.download(data.fileName, data.csv);
        }
      });
    },

    goTo(url) {
      this.$router.push(url);
    },
  },
};
</script>